


















import Vue from 'vue'
import { MIN_CHROME_VERSION } from '.'
import KisweStudioLogo from '@/components/Kiswe/KisweStudioLogo'

export default Vue.extend({
  name: 'ChromeMessage',
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    browserVersion (): string {
      if (!navigator) {
        return 'Unknown Browser'
      }
      //Return Chrome version or entire User Agent if not Chrome
      return navigator.appVersion?.split('Chrome/')?.[1]?.split(' ')?.[0] ?? navigator.userAgent
    },
    isChrome (): boolean {
      return navigator?.appVersion?.includes('Chrome')
    },
    minChromeVersion (): number {
      return MIN_CHROME_VERSION
    },
    isIOS (): boolean {
      return [
        'iPad Simulator', 'iPhone Simulator', 'iPod Simulator',
        'iPad', 'iPhone', 'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  components: {
    KisweStudioLogo
  }
})
